import moment from "moment";
import { ActorType, Group } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class ActorTypesAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get actor() {
        return capitalizeString(this.value.actor);
    }

    get collectionName() {
        return this.value.collection_name;
    }

    get updated_at() {
        return moment(this.value.date_updated).format("YYYY-MM-DD");
    }

    adapt(): ActorType {
        return {
            id: this.value.id,
            user_updated: "",
            user_created: "",
            date_created: "",
            date_updated: "",
            collection_name: this.collectionName,
            actor: this.actor,
            status: "",
            sort: "",
        };
    }
}
